export type FeatureApplianceDetailsTranslationKeys =
  | 'APPLIANCE_DETAILS_FORM_APPLIANCE_CODE_ERROR_REQUIRED'
  | 'APPLIANCE_DETAILS_FORM_APPLIANCE_CATEGORY_ERROR_REQUIRED';
